import { MapPin, Phone, MessageCircle, Navigation } from "lucide-react";
import { ADDRESS_FULL, ADDRESS_LINE, DAY_NAMES, MAP_EMBED, MAPS_DIR_URL, PHONE, PHONE_DISPLAY, WHATSAPP_URL } from "@/lib/clinic";
import { slotLabel } from "@/lib/api";

const ORDER = [1, 2, 3, 4, 5, 6, 0];

const HoursTable = ({ config }) => {
  const closed = config?.closed_days_of_week ?? [2];
  const hours = config ? `${slotLabel(config.opening_time)} – ${slotLabel(config.closing_time)}` : "10:00 AM – 6:00 PM";
  return (
    <table className="w-full text-sm" data-testid="hours-table">
      <tbody>
        {ORDER.map((d) => (
          <tr key={d} className="border-b border-slate-100 last:border-0">
            <td className="py-2 text-ink">{DAY_NAMES[d]}</td>
            <td className={`py-2 text-right font-medium ${closed.includes(d) ? "text-red-500" : "text-teal"}`} data-testid={`hours-${DAY_NAMES[d].toLowerCase()}`}>
              {closed.includes(d) ? "Closed" : hours}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const Btn = ({ href, icon: I, children, testid, primary }) => (
  <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 h-11 px-4 rounded-full text-sm font-semibold transition-colors ${primary ? "bg-teal text-white hover:bg-teal-dark" : "border border-slate-200 bg-white text-ink hover:bg-mint"}`}>
    <I className="h-4 w-4" />{children}
  </a>
);

export const Location = ({ config }) => (
  <section className="bg-white border-t border-slate-100" id="location" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 grid lg:grid-cols-2 gap-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-light mb-3">Visit us</p>
        <h2 className="text-3xl sm:text-4xl font-semibold text-ink">Easy to find, right above Ratnadeep</h2>
        <div className="mt-6 rounded-3xl bg-mint border border-mint-border p-6" data-testid="landmark-card">
          <p className="flex gap-3 font-display text-lg sm:text-xl text-teal font-semibold"><MapPin className="h-6 w-6 shrink-0 mt-0.5" />{ADDRESS_LINE}</p>
          <p className="mt-2 text-sm text-ink-muted pl-9">{ADDRESS_FULL}</p>
        </div>
        <div className="mt-6 rounded-3xl border border-slate-200 p-6">
          <p className="font-semibold text-ink mb-2">Working hours</p>
          <HoursTable config={config} />
        </div>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-2">
          <Btn href={`tel:${PHONE}`} icon={Phone} testid="location-call-button" primary>Call {PHONE_DISPLAY}</Btn>
          <Btn href={WHATSAPP_URL} icon={MessageCircle} testid="location-whatsapp-button">WhatsApp</Btn>
          <Btn href={MAPS_DIR_URL} icon={Navigation} testid="location-directions-button">Directions</Btn>
        </div>
      </div>
      <div className="rounded-3xl overflow-hidden border border-slate-200 min-h-[320px] lg:min-h-full bg-slate-100">
        <iframe title="Smileton Dental on Google Maps" src={MAP_EMBED} className="w-full h-full min-h-[320px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="location-map" />
      </div>
    </div>
  </section>
);
